var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "wrapper position-relative"
  }, [_vm._m(0), _vm._m(1), _c('div', {
    staticClass: "bg-bottom"
  }, [_c('div', {
    staticClass: "layer"
  }, [_c('div', {
    staticClass: "layer-point"
  }, [_c('div', {
    staticClass: "point-title"
  }, [_vm._v("累積點數")]), _c('div', {
    staticClass: "point"
  }, [_vm._v(_vm._s(_vm.availablePoints))])]), _c('router-link', {
    attrs: {
      "to": {
        name: 'LiffHuggiesMomoRedeem'
      }
    }
  }, [_c('div', {
    staticClass: "button"
  }, [_c('div', [_vm._v("我要兌換")]), _c('img', {
    staticClass: "button-caret",
    attrs: {
      "src": require("./images/momo_index_button_caret.png")
    }
  })])]), _c('router-link', {
    attrs: {
      "to": {
        name: 'LiffHuggiesMomoRedeemRecord'
      }
    }
  }, [_c('div', {
    staticClass: "button"
  }, [_c('div', [_vm._v("兌換紀錄")]), _c('img', {
    staticClass: "button-caret",
    attrs: {
      "src": require("./images/momo_index_button_caret.png")
    }
  })])]), _c('router-link', {
    attrs: {
      "to": {
        name: 'LiffHuggiesMomoPointRecord'
      }
    }
  }, [_c('div', {
    staticClass: "button"
  }, [_c('div', [_vm._v("點數紀錄")]), _c('img', {
    staticClass: "button-caret",
    attrs: {
      "src": require("./images/momo_index_button_caret.png")
    }
  })])]), _c('router-link', {
    attrs: {
      "to": {
        name: 'LiffHuggiesMomoProfile'
      }
    }
  }, [_c('div', {
    staticClass: "button"
  }, [_c('div', [_vm._v("兌獎資訊填寫")]), _c('img', {
    staticClass: "button-caret",
    attrs: {
      "src": require("./images/momo_index_button_caret.png")
    }
  })])])], 1)])]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "logo"
  }, [_c('img', {
    attrs: {
      "src": require("./images/momo_index_logo.png")
    }
  })]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "bg-top"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('img', {
    attrs: {
      "src": require("./images/momo_index_bg_title.png")
    }
  })])]);
}]

export { render, staticRenderFns }